import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { fetchreports, getProductList } from '../services/fetchreport'
import LoaderComponent from '../loaderComp/LoaderComponent'
import TableComponent from '../tableComponent/TableComponent'
import Select from '../SelectComponent/SelectComponent'
import FilterComponent from '../filterComponent/filterComponent'
import BookmarkComponent from '../BookmarkComponent/BookmarkComponent'
import { updateReportsData, updategenreports } from '../reduxstore/actions'
import PopoverGsspDownload from '../PopoverFavComponent/PopoverGsspDownload'
import NoRecordsFound from '../NoRecordsFound.png'
import { useLocation, useSearchParams } from 'react-router-dom'
import './Reportcontainer.scss'

interface ReportContainerProps {
  cntntid?: string
  savedreports: any[]
  userData: any[]
  isAdmin: boolean
  updateReports: (reports: any[]) => void
  updateGenReports: (reports: any[]) => void
}

function ReportContainer (props: ReportContainerProps): React.JSX.Element | null {

  const [userData, setuser] = useState<any[]>([])
  const [reports, setreports] = useState<any[]>([])
  const [noReports, setNoReports] = useState(false)
  const [hasError, setError] = useState(false)
  const [isFilterApplied, setFilterStatus] = useState(false)
  const [isloading, setLoading] = useState(false)
  const [products, setproducts] = useState<any[]>([])
  const [selectedProduct, setSelectedProduct] = useState('')
  const [hasAutoLoadedReports, setHasAutoLoadedReports] = useState(false)
  const [isRedirDownload, setIsRedirDownload] = useState(false)
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const cntntid = searchParams.get('cntntid')
  const isRedirUrlCheck = location.pathname.includes('/reports/gssp') && cntntid

  useEffect(() => {
    const getProductData = async () => {
      const productListResponse: any = await getProductList()
      const productsArr = Array.from(productListResponse as any)
      setproducts(productsArr)
      if (productsArr.length > 0) {
        const normalizedProducts = productsArr.map((product: any) => String(product))
        const absenceMgmtProduct = normalizedProducts.find((product: string) =>
          product.toLowerCase().includes('absence management')
        )
        const firstValidProduct = normalizedProducts.find((product: string) =>
          product.trim() !== '' && product.toLowerCase() !== 'product'
        )
        setSelectedProduct(absenceMgmtProduct || firstValidProduct || normalizedProducts[0] || '')
      }
    }
    getProductData()
  }, [])

  const reportdata = async (product: string, optionVal: number) => {
    if (optionVal > 0) {
      const user = userData[0]
      if (user) {
        setLoading(true)
        setNoReports(false)
        setError(false)
        try {
          const userDetails = {
            customerName: [user.customerName],
            reportName: 'string',
            reportNameDt: 'string',
            refreshIndicator: 'N',
            userRole: 'string',
            userType: user.userType,
            username: user.userName,
            userEmailAddr: user.userEmailAddr,
            encUserType: user.encUserType,
            encUserName: user.encUserName,
            encCustomerName: [user.encCustomerName],
            encUserEmailAddr: user.encUserEmailAddr,
            e_id: user.e_id

          }
          setSelectedProduct(product)
          const reportsdataRes = await fetchreports(userDetails)
          setLoading(false)
          if (reportsdataRes.status === 404 || reportsdataRes.status === 400 || reportsdataRes.status === 204) {
            setNoReports(true)
            setError(false)
          } else if (reportsdataRes.ok !== undefined && !reportsdataRes.ok) {
            setNoReports(true)
            setError(true)
          } else {
            const reportsdata = (reportsdataRes || []).filter((rep: any) => (rep.reportCategoryDesc ? rep.reportCategoryDesc : '').toLowerCase().includes(product.toLowerCase()))
            const modifiedreports: any[] = []
            if (reportsdata.length === 0) {
              setNoReports(true)
              setError(true)
            }
            reportsdata.map((rep: any) => {
              const record: any = {}
              record.id = rep.cust_file_id || rep.cust_file_int_id
              if (userData[0].userType.indexOf('Internal') > -1) {
                record.customerName = rep.customerName
              }
              record.reportName = rep.reportName
              record.reportType = rep.reportTypeDesc ? rep.reportTypeDesc : ''
              record.frequency = rep.reportFrequency
              record.updatedDate = rep.reportGenDate ? rep.reportGenDate : ''
              record.action = 'default'
              record.userTypeName = rep.userTypeName ? rep.userTypeName : ''
              record.reportId = rep.reportId ? rep.reportId : ''
              record.bookmark = rep.bookmarkStatus === 'true' ? 'RemoveBM' : 'CheckFav'
              modifiedreports.push(record)
              return rep
            })
            setreports(modifiedreports)
            setError(false)
            props.updateReports(modifiedreports)
            props.updateGenReports(reportsdata)
            setIsRedirDownload(Boolean(isRedirUrlCheck))
          }
        } catch (e) {
          console.log(e)
          setError(true)
          setIsRedirDownload(Boolean(isRedirUrlCheck))
        } finally {
          setLoading(false)
        }
      }
    } else {
      setLoading(false)
      setreports([])
      setIsRedirDownload(Boolean(isRedirUrlCheck))
    }
  }

  const setfilteredlist = (filter: any[]) => {
    const reportClone = [...props.savedreports]
    if (filter.length > 0) {
      const filterKeys: string[] = []
      const filterValues: string[] = []
      let filteredreports: any[] = []
      for (const values of filter) {
        const val = Object.keys(values)[0].replace(' ', '')
        filterKeys.push(val.charAt(0).toLowerCase() + val.slice(1))
        filterValues.push(String(Object.values(values)[0]).trim())
      }
      for (let i = 0; i < filterKeys.length; i++) {
        if (i === 0) {
          filteredreports = reportClone.filter(rep => rep[filterKeys[i]] && String(rep[filterKeys[i]]).toLowerCase().includes(filterValues[i].toLowerCase()))
        } else {
          filteredreports = filteredreports.filter(rep => rep[filterKeys[i]] && String(rep[filterKeys[i]]).toLowerCase().includes(filterValues[i].toLowerCase()))
        }
      }
      setreports(filteredreports)
      setFilterStatus(true)
    } else {
      setreports(reportClone)
      setFilterStatus(false)
    }
  }

  const getTableContent = () => {
    const customerList: string[] = []
    const reportTypeList: string[] = ['Report Type']
    const frequencyList: string[] = ['Frequency']
    let internalUser = false
    if (userData[0]?.userType?.indexOf('Internal') > -1) {
      internalUser = true
    }
    if (props.savedreports.length > 0) {
      for (const rep in props.savedreports) {
        customerList.push(props.savedreports[rep].customerName)
        if (props.savedreports[rep].reportType !== '') {
          reportTypeList.push(props.savedreports[rep].reportType)
        }
        frequencyList.push(props.savedreports[rep].frequency)
      }
      return (
        <FilterComponent filterData={setfilteredlist} customerList={[...new Set(customerList)]} reportTypeList={[...new Set(reportTypeList)]} frequencyList={[...new Set(frequencyList)]} isInternal={internalUser} />
      )
    }
    return null
  }

  const renderContent = useCallback(() => {
    if (userData.length > 0 && reports.length > 0) {
      let internalUser = false
      if (userData[0].userType.indexOf('Internal') > -1) {
        internalUser = true
      }
      const repClone = [...reports]
      const customers: string[] = []
      const repFreq: string[] = []
      for (const rep of repClone) {
        customers.push(rep.customerName)
        repFreq.push(rep.frequency)
      }
      const freqList = ['Daily', 'Weekly', 'Monthly', 'YTD', ...repFreq]
      const unqCust = [...new Set(customers)].sort()
      const unqFreq = [...new Set(freqList)]
      let sortedreports: any[] = []
      let filterFreq: any[] = []
      let sortedrn: any[] = []
      for (const cust of unqCust) {
        const filteredCust = repClone.filter(rep => rep.customerName === cust)
        for (const freq of unqFreq) {
          filterFreq = filteredCust.filter(rep => rep.frequency === freq)
          sortedrn = filterFreq.sort((a, b) => String(a.reportName || '').localeCompare(String(b.reportName || '')))
          sortedreports = [...sortedreports, ...sortedrn]
        }
      }
      const columnNames = Object.keys(sortedreports[0] || {})
      return <TableComponent columnNames= {columnNames} data={sortedreports} class={props.isAdmin ? 'admin' : internalUser ? 'report-data' : 'report-data-not' } rowperpage={10} isInternal={internalUser}/>
    } else if (userData.length > 0 && hasError) {
      return <div className={'has-Error'}>{'Due to technical issue, unable to retrieve the data, please try after some time'}</div>
    } else if (isFilterApplied && userData.length > 0 && reports.length === 0) {
      return <p className={'no-records-text'}> No matching records found</p>
    } else if (userData.length > 0 && noReports) {
      return <div className='col'><div className='no-records-img'><img src={NoRecordsFound} style={{ width: '100px', height: '90px' }}></img></div><p className={'no-records-text'}> No reports found. <br />Note that request tampering and unauthorized data manipulation is strictly prohibited, and is audited and reported.</p></div>
    } else {
      return null
    }
  }, [reports, userData, isFilterApplied, hasError, noReports, props.isAdmin])

  useEffect(() => {
    if (props.userData.length > 0) {
      setuser(props.userData)
    }
  }, [props.userData])

  // Trigger one initial fetch after both user and default product are available.
  // Skip the auto fetch for GSSP redirect links since reports data isn't needed there.
  useEffect(() => {
    if (!hasAutoLoadedReports && userData.length > 0 && selectedProduct) {
      if (!isRedirUrlCheck) {
        reportdata(selectedProduct, 1)
      }
      setHasAutoLoadedReports(true)
    }
  }, [userData, selectedProduct, hasAutoLoadedReports, isRedirUrlCheck])

  // GSSP popover must trigger solely based on the route/cntntid, independent of
  // whether the auto-selected product's report list fetch succeeds or returns empty.
  useEffect(() => {
    setIsRedirDownload(Boolean(isRedirUrlCheck))
  }, [isRedirUrlCheck])

  useEffect(() => {
    setreports(props.savedreports)
  }, [props.savedreports])

  return (
    <>
      {userData.length > 0 &&
        <div className={'report-container'}>
          <div>
            <div className={'search-container'}>
            {<div className= {'content-between'}> <h2 className={'report-header'}>Custom Reports</h2> {<div > <BookmarkComponent /></div>} </div>}
              {<Select className={'product-name'} defaultValue={'Product'} options={products} value = {selectedProduct} onChange = {(option: any) => setSelectedProduct(option)} onSelect={reportdata} />}
              {userData.length > 0 && (reports.length > 0 || isFilterApplied) && getTableContent()}
          </div>
            <div className={'table-section'}>
              {isloading ? <div className={'table-loader'}><LoaderComponent /></div> : renderContent()}
            </div>
            {userData.length > 0 && isRedirDownload && <PopoverGsspDownload cntntid={cntntid}/>}
          </div>
        </div>}
    </>

  )
}

const mapStateToProps = (state: any) => ({
  savedreports: state.reducers.reports,
  userData: state.reducers.userInfo,
  isAdmin: state.reducers.isAdmin
})

const mapDispatchToProps = (dispatch: any) => ({
  updateReports: (reports: any[]) => dispatch(updateReportsData(reports)),
  updateGenReports: (reports: any[]) => dispatch(updategenreports(reports))
})

export default connect(mapStateToProps, mapDispatchToProps)(ReportContainer)
